import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Session} from '../../interfaces/session-data';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Actions, Select, Store} from '@ngxs/store';
import {catchError} from 'rxjs/operators';
import {MapState} from 'src/app/components/shared/map.state';
import {OrderItem} from '../../interfaces/OrderItem';
import {ShippingDetails} from '../../interfaces/ShippingDetails';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Router} from '@angular/router';

export interface Order {
  itemName: string;
  quantity: number;
  amount: string;
}

export interface Shipping {
  recipient: string;
  address_line_1: string;
  address_line_2: string;
  address_line_3: string;
  address_line_4: string;
  address_line_5: string;
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // and route not error

  @Select(MapState.sessionStorage) sessionStorage$: Observable<Session>;
  errorObject: any;
  loading: true;
  displayedColumnsOrder: string[] = ['itemName', 'quantity', 'amount'];
  displayedColumnsShipping: string[] = ['recipient', 'address_line_1', 'address_line_2', 'address_line_3', 'address_line_4', 'address_line_5'];
  sessionData: Session;
  public headerData = {
    product: '',
    buttonOrderDetails: 'View Order Details'
  };
  product: string;
  buttonOrderDetails: string;
  colorScheme;
  mobile;
  routeError;
  mobileLabel;
  expanded = false;

  constructor(
    public dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    actions$: Actions,
    private store: Store,
    private cdr: ChangeDetectorRef,
    private breakpointObserver: BreakpointObserver,
    private router: Router) {

    breakpointObserver.observe([
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
    // actions$.pipe(
    //   ofActionDispatched(SetSessionStorage))
    //   .subscribe(({ payload }) => {
        // this.sessionData = payload;

      // });
  }

  ngOnInit() {
    this.sessionStorage$.pipe(
      catchError(err => {
        this.errorObject = err;
        this.changeDetectorRef.detectChanges();
        return throwError(err);
      })
    );
    this.routeError = this.router.url.indexOf('/error') > -1;
    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    // this.sessionStorage$ = this.sessionData;
    this.colorScheme = '#009dd3';
    if (this.sessionData) {
      if (this.sessionData.sessionDisplayInformation) {
        this.headerData.product = this.sessionData.sessionDisplayInformation.label;
        if(this.headerData.product.length>20){
          this.mobileLabel = this.headerData.product.substr(0,17);
          this.mobileLabel = this.mobileLabel.concat("","...");
        }
        if (this.sessionData.sessionDisplayInformation.colorScheme) {
          this.colorScheme =
            this.sessionData.sessionDisplayInformation.colorScheme.slice(
              0,
              this.sessionData.sessionDisplayInformation.colorScheme.length - 1);
        } else if (this.sessionData.sessionDisplayInformation.defaultColorScheme) {
          this.colorScheme =
            this.sessionData.sessionDisplayInformation.defaultColorScheme.slice(
              0,
              this.sessionData.sessionDisplayInformation.defaultColorScheme.length - 1
            );
        }
      }
    }

    // if (!this.sessionData && sessionStorage.getItem('theme')) {
    //   this.sessionData = {
    //     orderItems: null,
    //     sessionDisplayInformation: null,
    //     savedCards: null,
    //     virtualConfiguration: null,
    //     virtualRoute: null,
    //     shippingDetails: null
    //   };
    //   if (JSON.parse(sessionStorage.getItem('theme'))) {
    //     this.sessionData.sessionDisplayInformation = JSON.parse(sessionStorage.getItem('theme'));
    //   }
    // } else if (!this.sessionData.sessionDisplayInformation && sessionStorage.getItem('theme')) {
    //   this.sessionData = {
    //     orderItems: null,
    //     sessionDisplayInformation: null,
    //     savedCards: null,
    //     virtualConfiguration: null,
    //     virtualRoute: null,
    //     shippingDetails: null
    //   };
    //   if (JSON.parse(sessionStorage.getItem('theme'))) {
    //     this.sessionData.sessionDisplayInformation = JSON.parse(sessionStorage.getItem('theme'));
    //   }
    // }


    this.cdr.detectChanges();
    // if (sessionStorage.getItem(('sessionData')) && sessionStorage.getItem(('sessionData')) !== 'null') {
    //   if (JSON.parse(sessionStorage.getItem(('sessionData'))) && !this.sessionData) {
    //     this.store.dispatch(new SetSessionStorage(JSON.parse(sessionStorage.getItem(('sessionData')))));
    //
    //   }
    // }

  }

  showOrderDetails() {

    let orders: OrderItem[];
    let shipping: ShippingDetails;
    // retrieves orders from session data
    orders = this.sessionData.orderItems;
    shipping = this.sessionData.shippingDetails;
    const dialogRef = this.dialog.open(OrderDetailsDialogComponent, {
      width: '300px',
      height: 'fit-content',
      maxHeight: '400px',
      data: {orders, shipping}
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

}

@Component({
  selector: 'app-order-details-dialog',
  templateUrl: './order-details/order-details-dialog.html',
  styleUrls: ['./order-details/order-details-dialog.scss']
})
export class OrderDetailsDialogComponent {

  recipient: string;
  shippingAddress1: string;
  shippingAddress2: string;
  shippingAddress3: string;
  shippingAddress4: string;
  shippingAddress5: string;
  shippingGroup: FormGroup;
  dataSourceOrder: any;
  displayedColumnsOrder: string[] = ['itemName', 'quantity', 'amount'];
  displayedColumnsShipping: string[] = ['recipient', 'address_line_1', 'address_line_2', 'address_line_3', 'address_line_4', 'address_line_5'];

  constructor(
    public dialogRef: MatDialogRef<OrderDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { orders: OrderItem[], shipping: ShippingDetails }, private fb: FormBuilder) {
      this.createForm();
      this.dataSourceOrder = new MatTableDataSource<OrderItem>(data.orders);
      this.recipient = data.shipping.recipient;
      this.shippingAddress1 = data.shipping.shippingAddress1;
      this.shippingAddress2 = data.shipping.shippingAddress2;
      this.shippingAddress3 = data.shipping.shippingAddress3;
      this.shippingAddress4 = data.shipping.shippingAddress4;
      this.shippingAddress5 = data.shipping.shippingAddress5;

    }

    createForm() {
      this.shippingGroup = this.fb.group({
      });
    }

}
